module.exports = {
  // 界面
  refresh: '刷新',
  the_side_slip: '側邊伸縮',
  close_current_tab: '關閉當前標籤頁',
  close_other_tab: '關閉其它標籤頁',
  close_all_tab: '關閉全部標籤頁',

  //類別
  add_next_level: '新增下一級',
  add_same_level: '新增同一級',
  parent_category: '上級分類',

  //通用
  new: '新增',
  copy_new: '複製新增',
  choose_new: '選擇新增',
  edit: '修改',
  delete: '刪除',
  batch_delete: '批量刪除',
  ok: '確定',
  save: '儲存',
  copy: '複製',
  save_and_copy: '儲存並複製',
  confirm_and_copy: '確定並複製',
  cancel: '取消',
  reset: '重置',
  refresh: '刷新',
  input_search_content: '輸入查詢內容...',
  name: '名稱',
  name2: '姓名',
  full_name: '姓名',
  full_name2: '全稱',
  is_valid: '是否有效',
  yes: '是',
  no: '否',
  none: '沒有',
  have: '有',
  nothing: '無',
  infomation: '信息',
  remark: '備註',
  description: '描述',
  serial_no: '流水號',
  close: '關閉',
  audit: '審核',
  unaudit: '反審',
  color: '顏色',
  color2: '顏料',
  is_cash: '是否現金',
  is_default: '是否默認',
  print: '列印',
  reprint: '重印',
  import: '匯入',
  export: '匯出',
  menu: '菜單',
  quotation: '報價單',
  message: '信息',
  quote_item: '報價項目',
  preview: '預覽',
  download: '下載',
  batch: '批次',
  plan_no: '計劃單號',
  result: '結果',
  image: '圖片',
  content: '內容',
  content2: '正文',
  introduction: '簡介',
  sort_order: '排序',
  choose_image: '選擇圖片',
  choose_file: '選擇文件',
  no_nodes: '沒有節點',

  //通用功能介面
  supplier_category: '供應商分類',
  supplier: '供應商',
  client: '客戶',
  payment_method: '結算方式',
  payment_method2: '支付方式',
  warehouse: '倉庫',
  code: '編碼',
  code2: '代碼',
  model: '型號',
  bracket_model: '支架型號',
  standard: '規格',
  unit: '單位',
  category: '分類',
  goods_category: '貨品分類',
  goods_category2: '商品分類',
  positions: '倉位',
  date: '日期',
  please_choose: '請選擇',
  invoice_no: '發票號',
  po_no: '採購單號',
  po_no2: 'PO No.',
  view: '查看',
  goods: '貨品',
  goods2: '商品',
  org_name: '機構名稱',
  org: '機構',
  total: '合計',
  retail_price: '零售價',
  retail_price2: '零售價2',
  mini_retail_price: '最低零售價',
  consignment_price: '寄賣價',
  login: '登入',
  logout: '登出',
  change_password: '修改密碼',
  the_front: '前台',
  the_back: '後台',

  contacts: '連絡人',
  contact_person: '連絡人',
  contacts_department: '連絡人部門',
  contacts_post: '連絡人職位',
  post: '崗位',
  mobile: '手提電話',
  office_phone: '辦公電話',
  fax: '傳真',
  email: '電子郵箱',
  post_code: '郵遞區號',
  zip_code: '郵政編碼',
  address: '地址',
  address2: '住址',
  website: '網址',
  website2: '網站',
  bank_account: '銀行戶口',
  accounts_receivable: '應收賬款',
  accounts_payable: '應付賬款',

  workshop: '車間',
  phone: '電話',
  principal: '負責人',

  accountbook: '帳簿',
  ticket_number: '票據號',

  cost: '成本',
  total_cost: '總成本',
  brand: '品牌',
  barcode: '條形碼',
  barcode2: '條形碼',
  qrcode: '二維碼',
  imei: 'IMEI',

  search: '搜尋',
  auto_search: '自動搜尋',
  manual_search: '手動搜尋',
  confirm: '確定',
  discount: '折扣',
  sell_price: '銷售價',
  seller: '售貨員',
  member: '會員',
  member_name: '會員姓名',
  goods_search: '貨品查找',
  hold_receipt: 'Hold單',
  unchecked: '未結賬',
  order: '預訂',
  order_report: '預訂報表',
  pay_money: '付款金額',
  paid_money: '已付金額',
  unpaid_money: '未付金額',

  in_warehouse: '轉入倉庫',
  out_warehouse: '轉出倉庫',

  sundry_category: '雜項分類',
  money: '金额',
  is_tax: '含稅',
  tax_amount: '含稅金額',
  tax_point: '稅點',
  tax_rate: '稅率',
  profit: '利潤',
  profit_rate: '利潤率',
  profit_rate2: '利率',

  user_group: '用戶組',
  user: '使用者',
  is_see_money: '查看金額',
  is_see_cost: '查看成本',
  is_stock_reminder: '存貨提醒',
  is_expired_reminder: '過期提醒',

  is_front: '可用前台',
  remember_login_name: '記住登入名',
  remember_password: '記住密碼',
  expiry_date: '到期日期',
  cashier: '收銀員',
  is_hold: '是否Hold單',
  is_order: '是否預訂',
  walk_in: '散客',
  amount_received: '已收金額',
  discount_money: '折扣金額',
  payment: '付款',
  settle: '結賬',
  obsolete: '作廢',
  exchange: '換貨',
  return: '退貨',
  return2: '返回',
  return_and_exchange: '退/換 貨',
  total_quantity: '合計數量',
  change: '找贖',
  total_amount: '總金額',
  pay_money: '實收金額',
  upload: '上傳',
  fuzzy_query: '模糊查詢',
  shelf_lift: '保質期',
  maintenance_period: '保養期',
  to_warehouse: '轉到倉庫',
  from_warehouse: '來自倉庫',
  stock_transfer_in: '轉倉入',
  summary_data: '匯總數據',
  detail_data: '明細數據',
  shop: '店鋪',
  item: '項目',
  source_quantity: '原數量',
  confirm_and_stay: '确定並停留',
  total_quantity: '總數量',
  confirm_password: '確認密碼',

  delivery_person: '送貨員',
  status: '狀態',
  state: '狀態',
  stock_state: '倉存狀態',
  order_date: '訂單日期',
  order_time: '訂單時間',
  order_date2: '落單日期',
  order_time2: '開單時間',
  order_date3: '接單日期',
  order_time4: '下單時間',
  order_date4: '下單日期',
  delivery_date: '送貨日期',
  delivery_date2: '交貨日期',
  delivery_date3: '交貨期',
  delivery_time: '送貨時間',
  delivery_time2: '交貨時間',
  order_flag: '訂單記號',
  client_family_name: '客人姓氏',
  client_phone: '客人電話',
  other: '其他',
  extra_year: '額外一年保',
  area: '地區',
  area2: '區域',
  area3: '所在區域',
  update: '更新',
  update_man: '更新',
  start_time: '開始時間',
  end_time: '結束時間',
  invoice_date: '發票日期',
  invoice_date2: '開票日期',
  is_invoice: '開票',
  invoice_info: '開票資料',
  drilling_wall: '鑽牆',
  handler: '經手人',
  uses: '用途',

  total_salary: '總薪金',
  base_salary: '底薪',
  commission: '佣金',
  special_bonus: '特別獎金',
  bonus: '獎金',
  maintain_commission: '維修佣金',
  maintain_expense: '維修支出',
  maintain_bonus: '維修獎金',
  maintenance_bonus: '保養獎金',
  maintenance_expense: '保養支出',
  maintenance_spare: '保養備用',

  type: '類型',
  type2: '類別',
  sundry_expenditure: '雜項支出',
  salary_expenditure: '薪金支出',
  fixed_expense: '固定支出',
  shop_expense: '店鋪支出',
  extra_expense: '額外支出',
  netprofit: '純利潤',
  export_excel: '匯出Excel',

  current_password: '當前密碼',
  new_password: '新密碼',
  print_invoice: '列印發票',
  job_title: '職位',
  supplier_name: '供應商名稱',
  modify_time: '修改時間',
  last_modify_time: '最後修改時間',
  for_delivery: '待送貨',
  processing: '處理中',
  total_sales_volume: '總銷量',
  a_month_total_sales_volume: '一個月總銷量',
  difference_quantity: '差額',
  replenish_application: '補貨申請',
  application_quantity: '申請數量',
  audit_quantity: '審核數量',
  replenish_quantity: '補貨數量',
  replenish_amount: '補貨金額',
  estimated_date: '預計到貨日期',

  project: '項目',
  project2: '工程',
  project_no: '工程號',
  project_category: '項目分類',
  project_code: '項目編號',
  project_name: '項目名稱',
  project_address: '項目地址',
  deduct: '扣除',
  bank: '銀行',
  account_name: '戶口名稱',
  account_no: '戶口號碼',

  maintenance_status: '維修狀態',
  notification_status: '通知狀態',
  expected_finish_day: '預計完成日',
  income_expenditure: '收入/支出',
  amount_mop: '金額/MOP',
  amount_hk: '金額/HK',
  reimbursement_people: '報銷人',
  month_sell_quantity: '月銷量',
  sales_volume: '銷量',
  version: '版本',

  //Table分頁文字
  table_jump_to: '到第',
  table_page: '頁',
  table_go: '確定',
  table_total: '共',
  table_item: '條',
  table_limit_each_page: '條/頁',

  password: '密碼',
  verify_password: '驗證密碼',
  login_name: '登入名',
  nickname: '暱稱',
  user_nickname: '用戶暱稱',

  summary: '摘要',
  bank_name: '銀行名稱',
  bank_name2: '開戶行',
  bank_card_no: '銀行卡號',
  balance: '餘額',
  balance_mop: '餘額/MOP',
  balance_hk: '餘額/HK',
  account_holder: '開戶人',
  last_period_balance: '上期結餘',
  last_period_balance2: '上期餘額',

  //Table Title文字
  id: 'ID',
  amount: '金額',
  price: '單價',
  quantity: '數量',
  goods_code: '貨品編號',
  goods_name: '貨品名稱',
  goods_code2: '商品編號',
  goods_name2: '商品名稱',
  is_audit: '審核',
  electroplate: '電鍍',
  is_electroplate: '電鍍',
  polishing: '拋光',
  is_polishing: '拋光',

  receivable: '應收金額',
  payable: '應付金額',
  deposit: '訂金',
  title: '標題',
  special_price: '特價',

  // 倉庫
  leader: '負責人',
  tel: '電話',
  location: '位置',

  //维修单
  acceptance_date: '受理日期',
  client_name: '客人名稱',
  client_name2: '客戶名稱',
  acceptance_model: '受理機型',
  serial_number: '串號',
  serial_number2: '序號',
  serial_number3: '編號',
  graphic_lock: '圖形鎖',
  maintain_history: '維修歷史',
  warranty_status: '保修狀態',
  follow_parts: '隨機配件',
  fault_cause: '故障原因',
  fault_phenomenon: '故障現象',
  need_parts: '所需配件',
  maintain_evaluate: '維修估價',
  advance_payment: '預交款',
  spare_phone: '備用手機',
  spare_model: '備用機型',
  retrieve_date: '取機日期',
  acceptance_status: '受理狀態',

  choose_delivery_note: '選擇送貨單',
  export_pdf: '匯出PDF',
  export_list: '匯出列表',
  export_monthly_analyze: '匯出月份分析',
  reinforcemoney: '保固金',
  reminder_date: '提醒日期',
  total_money: '總金額',
  incomepay_type: '收支類別',
  difference_cost: '差額成本',
  sell_date: '銷售日期',
  setting_sales_volume: '設定銷量',
  negative_difference_quantity: '負差額',
  exchange_rate: '匯率',

  product_category: '產品分類',
  product_category2: '產品類別',
  product_category3: '成品分類',
  product: '產品',
  product2: '成品',
  problem_type: '問題類型',
  item_count: '項目總數',
  function: '功能',
  handling_type: '處理類型',
  handling_description: '處理描述',

  audited: '已審覈',
  unaudited: '未審覈',
  all: '全部',
  credit: '貸款',
  repayment: '還款',
  credit_amount: '貸款金額',
  repayment_amount: '還款金額',
  pay_type: '支付類型',
  paid: '已付款',
  unpaid: '未付款',
  make_journal: '生成日記帳',
  cash_journal: '現金日記帳',
  bank_journal: '銀行日記賬',
  invoice_journal: '支票日記賬',
  receive_reminder: '接收提醒',
  income: '收入',
  total_income: '總收入',
  expenditure: '支出',
  last_in_cost: '最近入庫成本',
  stock_cost: '倉存成本',
  cash_balance_mop: '現金餘額MO',
  cash_balance_hk: '現金餘額HK',
  bank_balance_mop: '銀行餘額MO',
  bank_balance_hk: '銀行餘額HK',
  invoice_balance_mop: '支票餘額MO',
  invoice_balance_hk: '支票餘額HK',
  check_no: '支票號',
  is_get: '是否已領取',
  is_get2: '已領取',
  not_get: '未領取',
  payment_entry: '付款錄入',
  payment_type: '付款類型',
  payment_type2: '收付款類型',
  show_index: '顯示序號',
  quote_remark: '報價備註',

  greater_than_zero: '大於0',
  equal_to_zero: '等於0',
  less_than_zero: '小於0',
  greater_than_zero2: '>0',
  equal_to_zero2: '=0',
  less_than_zero2: '<0',

  previous_day: '前一天',
  purchase_in: '採購入庫',
  purchase_return: '採購退貨',
  stock_transfer_out: '轉倉出',
  consignment_out: '寄賣發出',
  consignment_in: '寄賣退貨',
  retail: '零售',
  retail_return: '零售 - 退貨',
  stock_adjust: '庫存調整',
  current_day: '當前日期',
  add_deposit: '增加訂金',
  order_quantity: '預訂數量',
  order_quantity2: '訂單數量',
  arrival_date: '到貨日期',
  picture: '圖片',
  goods_detail: '貨品詳情',
  goods_detail2: '商品詳情',
  spec_parameter: '規格/參數',
  spec_parameter2: '規格參數',
  extend_price: '擴展單價',
  open_time: '營業時間',
  booking: '預訂',
  new_product: '新品',
  spot_sale: '現貨發售',
  is_corporate_account: '是否公賬',
  corporate_account: '公賬',
  keep_accounts: '記賬',
  sort: '分類',
  miniprogram: '小程序',
  miniprogram_price: '小程序單價',
  delivery_way: '配送方式',
  service: '服務',
  value_added_services: '增值服務',
  extended_warranty: '延長保養',
  size: '尺碼',
  size2: '尺寸',
  month: '月',
  month2: '月份',
  day: '天',
  send: '發送',
  detail_address: '詳細地址',
  delivery_place: '出貨地點',
  contracted_address: '簡約地址',
  job_content: '工作內容',
  foreign_name: '外文名',
  spec: '規格',
  spec2: '規格型號',
  product_code: '產品編號',
  product_code3: '成品編號',
  product_name: '產品名稱',
  product_name3: '成品名稱',
  product_spec: '產品規格',
  product_spec2: '產品型號',
  product_spec3: '成品規格',
  stuff_code: '材料編號',
  stuff_name: '材料名稱',
  stuff_spec: '材料規格',
  stuff_spec2: '材料規格型號',
  material_code: '材料編號',
  material_code2: '物料編號',
  material_name: '材料名稱',
  material_name2: '物料名稱',
  material_spec: '材料規格',
  material_spec2: '材料規格型號',
  material_spec3: '物料規格',
  goods_spec: '貨品規格',
  goods_spec2: '貨品規格型號',
  semi_finished_code: '半成品編號',
  semi_finished_name: '半成品名稱',
  semi_finished_spec: '半成品規格',
  semi_finished_spec2: '半成品規格型號',
  system_item_can_not_edit: '系統項目,不能修改',
  system_item_can_not_delete: '系統項目,不能刪除',
  uses: '用途',
  supply_code: '供應代碼',
  is_occupy_can_not_unaudit: '已被佔用，不能反審',
  receive_payment_date: '收款日期',
  payment_date: '付款日期',
  delivery_no: '送貨單號',
  reconcile_date: '對賬日期',
  reconcile_month: '對賬月份',
  receipt_date: '單據日期',
  receipt_start_date: '單據開始日期',
  receipt_end_date: '單據結束日期',
  short_name: '簡稱',
  client_short_name: '客人簡稱',
  supply_type: '供貨類型',
  sell_type: '銷售類型',
  stuff: '材料',
  material: '材料',
  semi_finished: '半成品',
  semi_finished_product: '半成品',
  client_order_no: '客戶訂單號',
  sell_order_no: '銷售訂單號',
  maker: '制單',
  auditor: '審覈',
  auditor2: '審覈人',
  time_unit_price: '工時單價',
  delivery_quantity: '交貨數量',
  delivery_quantity2: '送貨數量',
  owe_quantity: '欠數',
  order_amount: '訂單金額',
  total_man_hour: '總工時',
  production_date: '生產日期',
  person_number: '人數',
  person_man_hour: '人員工時',
  man_hour: '工時',
  material_price: '物料價',
  check_stock: '檢查倉存',
  packages: '件數',
  is_xcx: '是否小程序',
  is_web: '是否網站',
  stock: '倉存',
  handling_method: '處理方法',
  problem: '問題',
  guarantee_clause: '保養條款',
  privacy_policy: '隱私條款',
  user_agreement: '用戶協議',
  user_guide: '用戶指南',
  contact_us: '聯絡我們',

  create_date: '創建日期',
  create_time: '創建時間',
  create_by: '開單人',
  create_by2: '創建人',
  creater: '創建人',
  application_date: '申請日期',
  application_date2: '申請時間',
  modify_date: '修改日期',
  clear: '清除',

  edit_mode: '编辑模式',
  close_other: '關閉其他',
  close_all: '關閉全部',
  close_this: '關閉當前',

  start_date: '開始日期',
  end_date: '結束日期',
  select_week: '選擇周',
  query_condition: '搜尋條件',

  stock_limit: '倉存上限',
  stock_lower: '倉存下限',
  mini_stock: '最小倉存',
  safe_stock: '安全倉存',
  max_stock: '最大倉存',
  add_material: '加料',
  add_material_money: '加料金額',
  turnover: '營業額',
  sales_ranking: '銷量',
  total_sales_ranking: '總銷量',
  stock_location: '倉位',
  yesterday: '昨天',
  today: '今日',
  this_month: '當月',
  a_month: '一個月',
  last_month: '上個月',
  this_year: '今年',
  last_year: '去年',
  setmeal: '套餐',
  process: '工序',
  process2: '工藝',
  length: '長度',
  height: '高',
  height2: '高度',
  chipset: '芯片',
  chipset2: '機芯',
  hour_minute_hand: '時分針',
  second_hand: '秒針',
  finished: '已完成',
  unfinished: '未完成',
  sell_out_quantity: '銷售數量',
  sell_out_quantity2: '出貨數量',
  wechat: '微信',
  consignment_category: '寄售分類',
  order_no: '訂單號',
  stock_quantity: '倉存數量',
  is_used: '已使用',
  used: '已使用',
  unused: '未使用',
  subtotal: '小計',
  sell_out_date: '出貨日期',
  sheets: '片數',
  pieces: '支數',
  backup: '備份',
  spare: '士啤',
  floor: '樓層',
  category_type: '分類類型',

  grade: '等級',
  auto_coding: '自動編碼',
  manual_coding: '手動編碼',
  hour: '小時',
  hour2: '時',
  minute: '分鐘',
  minute2: '分',
  sceond: '秒',
  negotiation_date: '洽談日期',
  negotiator: '洽談人',
  next_date: '下次日期',
  next_content: '下次內容',
  is_connected: '已聯絡',
  final_date: '完成日期',
  final_time: '完成時間',
  ask_executor: '任務執行人',
  take_time: '用時',
  task_content: '任務內容',
  tester: '測試員',
  task_finish_type: '任務完成類型',
  finish_flag: '完成標記',
  issue_category: '問題分類',
  issue_collection: '問題收集',
  issue_content: '問題內容',
  project_status: '項目狀態',
  create_task: '生成任務',
  service_name: '服務名稱',
  service_item: '服務項目',
  service_details: '服務詳情',
  service_fee: '服務費',
  active_status: '在職狀態',
  staff: '員工',
  staff_code: '員工編號',
  staff_name: '員工姓名',
  task_type: '任務類型',
  default_price: '預設單價',
  default_purchase_price: '預設採購價',
  default_sell_price: '預設銷售價',
  material_category: '材料分類',
  material_category2: '物料分類',
  semi_finished_category: '半成品分類',
  addressee: '收貨人',
  receipt_date: '收貨日期',
  delivery_person: '送貨人',
  remaining_quantity: '剩餘數量',
  remaining_quantity2: '結餘數量',
  finish_quantity: '完成數量',
  inventory_quantity: '入倉數量',
  stock_in_type: '轉倉入類型',
  stock_out_type: '轉倉出類型',
  molds: '模具',
  molds2: '模條',
  card_slot: '卡位',
  formula: '公式',
  formula2: '配方',
  modifier: '修改人',
  diffuser: '擴散劑',
  sell_order: '銷售訂單',
  unit_quantity: '單位數量',
  production_order: '生產計劃',
  sex: '性別',
  birthday: '生日',
  id_card: '身份證',
  department: '部門',
  hiredate: '入職日期',
  salesman: '業務員',
  salesman2: '業務',
  calc_attendance: '計算考勤',
  attendance: '考勤',
  production_no: '生產單號',
  category_code: '分類編碼',
  client_product_code: '客戶產品編碼',
  client_product_code2: '客戶成品編碼',
  buyer: '採購員',
  purchase: '採購',
  client_order: '客戶訂單',
  sell_billing: '銷售開單',
  client_return: '客戶退貨',
  sell_summary: '銷售匯總',
  yield_rate: '良品率',
  stock_alert: '倉存預警',
  inspection_type: '檢驗類型',
  product_description: '產品描述',
  inspection_quantity: '檢驗數量',
  inspector: '檢驗人',
  inspector2: '檢驗員',
  inspection_result: '檢驗結果',
  inspection_remark: '檢驗備註',
  overdue: '逾期',
  audit_time: '審覈時間',
  customer_complaint: '客訴',
  process_result: '處理結果',
  defect_rate: '不良率',
  improvement_plan: '改善方案',
  wilfulness: '負責人',
  month_of_payment: '貨款月份',
  invoice_money: '開票金額',
  invoice_money2: '發票金額',
  recorder: '記錄人',
  analyst: '分析人',
  logger: '錄入員',
  reason_for_sending_samples: '送樣原因',
  sample_name: '樣板名稱',
  material_process: '材料工藝',
  producer: '製作員',
  rewards: '獎勵',
  punishments: '懲罰',
  points: '積分',
  order_review: '訂單評審',
  quality_manage: '品質管理',
  material_inspection: '材料檢驗',
  material_inspection2: '來料檢驗',
  product_inspection: '產品檢驗',
  admin_manage: '行政管理',
  attendance_entry: '考勤錄入',
  overtime_entry: '加班錄入',
  wage_entry: '人工錄入',
  wage_date: '人工日期',
  wage_month: '人工月份',
  outsource_supplier_category: '外發供應商分類',
  outsource_supplier: '外發供應商',
  outsource_count: '外發統計',
  outsource_statement: '外發對賬單',
  outsource_return: '外發退料',
  cost_estimation: '成本估算',
  feedback: '反饋',
  client_feedback: '客戶反饋',
  improve: '改進',
  improve_plan: '改進計劃',
  base_data: '基礎數據',
  clear_image: '清除圖片',
  production_quantity: '生產數量',
  order_type: '訂單類別',
  parameter: '參數',
  packaging: '打包',
  packaging_reqs: '打包要求',
  package_spec: '打包規格',
  package_quantity: '打包數量',
  purchase_dep: '採購部',
  production_dep: '生產部',
  quality_dep: '品質部',
  mold_number: '模具號',
  client_remark: '客戶備註',
  shift: '班次',
  shift2: '輪班',
  coefficient: '系數',
  process_route: '工藝路線',
  process_tech: '工藝工序',
  process_list: '工序列表',
  defective_items: '不良品項',
  out_quantity: '出庫數量',
  in_quantity: '入庫數量',
  reporting_auth: '報工權限',
  reporting_date: '報工日期',
  planned_date: '計劃完成日期',
  planned_completion_date: '計劃完成日期',
  plan_final_date: '計劃完成日期',
  receiver: '收款人',
  payer: '付款人',
  return_goods: '返回貨品',
  return_quantity: '退貨數量',
  return_quantity2: '返回數量',
  return_date: '退貨日期',
  return_date2: '歸還日期',
  acceptable_quantity: '良品數',
  defective_quantity: '不良品數',
  uration: '時長',
  attendance_type: '考勤類型',
  net_pay: '實發人工',
  piecework: '計件',
  overtime: '加班',
  earnings: '增加項',
  social_insurance: '社保',
  deductions: '減少項',
  earnings_type: '增加項類型',
  earnings_entry: '增加項錄入',
  deductions_type: '減少項類型',
  deductions_entry: '減少項錄入',
  designator: '位號',
  sales_manager: '業務主管',
  is_sales_manager: '業務主管',
  order_coordinator: '跟單',
  is_order_coordinator: '跟單',
  order_manager: '跟單主管',
  is_order_manager: '跟單主管',
  accident_ins: '意外保險',
  buy_accident_ins: '購買意外保險',
  accident_date: '意外險日期',
  buy_accident_date: '購買意外險日期',
  buy_social_ins: '購買社保',
  health_report: '體檢報告',
  project_dept: '所屬項目部門',
  exp_status: '經驗狀態',
  edu: '學歷',
  edu_major: '所學專業',
  age: '年齡',
  marital: '婚姻狀態',
  work_years: '工齡',
  contract_date: '簽署合同日期',
  resign_apply: '申請離職',
  resign_apply_date: '申請離職日期',
  resign_date: '離職日期',
  uniform_date: '制服領取日期',
  uniform_date2: '工衣領取日期',
  emergency_phone: '緊急聯繫方式',
  emergency_phone2: '緊急聯繫人聯繫方式',
  reg_addr: '戶籍地址',
  purchase_order_reminder: '採購訂單提醒',
  remind: '提醒',
  delayed_reminder: '延時提醒',
  Select_delay_time: '選擇延遲時間',
  purchase_in_serial_no: '採購入庫單號',
  counterparty: '對接單位',
  counterparty2: '交易方',
  client_quotation: '客戶報價',
  sample_sheet: '送樣單',
  required_quantity: '要求數量',
  sample_quantity: '送樣數量',
  remote_control: '配套遙控',
  accessories: '配件',
  sample_request_date: '下樣板日期',
  sample_delivery_date: '送樣日期',
  production_method: '出品方式',
  sample_feedback_record: '樣板回訪記錄',
  standard: '標準',
  material_image: '板材圖片',
  voltage: '電壓',
  project_initiation: '立項單',
  product_name2: '產品命名',
  project_start_date: '立項時間',
  eval_drawing_completion: '評估畫板完成時間',
  eval_closing: '評估結案時間',
  actual_drawing_date: '實際畫板時間',
  actual_closing_date: '實際結案時間',
  dev_code: '開發代碼',
  customer_code: '客戶代碼',
  full_data_date: '齊開發資料時間',
  design_dev_description: '設計開發內容描述',
  dev_requirement: '開發要求描述',
  electrical_requirements: '電氣特性要求',
  input_voltage: '輸入電壓',
  output_spec: '輸出規格',
  safety_req: '安規要求',
  esd_req: 'ESD要求',
  hipot_test_standard: '高壓測試標準',
  project_initiation_serial_no: '立項單號',
  sample_status: '樣板狀態',
  exception_record: '異常單記錄',
  batch: '批量',
  production_unit: '生產單位',
  product_type: '產品類型',
  product_type2: '成品類型',
  defect: '缺陷',
  defect_symptom: '缺陷症狀',
  responsibility_judgment: '責任判斷',
  feedback_department: '反饋部門',
  feedback_person: '反饋人',
  feedback_date: '反饋日期',
  defect_reason: '不合格原因',
  defect_reason_confirmer: '不合格原因確認人',
  defect_reason_confirmed_date: '不合格原因確認日期',
  action_plan: '處理方案',
  action_plan_confirmer: '處理方案確認人',
  action_plan_confirmed_date: '處理方案確認日期',
  qa_countersign: '品質部門會簽',
  qa_countersign_confirmer: '品質部門會簽確認人',
  qa_countersign_confirmed_date: '品質部門會簽確認日期',
  action_status: '措施實施情況',
  action_standardization: '措施標準化',
  action_confirmer: '措施確認人',
  action_confirmed_date: '措施確認時間',
  action_auditor: '措施審覈人',
  action_audited_date: '措施審覈時間',
  production_plan: '生產計劃',
  production_plan_serial_no: '生產計劃單號',
  place: '地點',
  person_count: '人數',
  requester: '申請人',
  eng_docs_archive: '工程資料歸檔',
  archive_type: '歸檔類型',
  document: '文檔',
  doc_name: '文檔名稱',
  image_name: '圖片名稱',
  product_packaging_management: '產品包裝管理',
  label_note: '標貼說明',
  to_department: '派送部門',
  sampling_quantity: '抽檢數量',
  check_date: '檢查日期',
  check_requirement: '检查要求',
  purchase_order: '採購訂單',
  stain: '污漬',
  damage: '破損',
  deformation: '變形',
  scratch: '划痕',
  dimension_mismatch: '尺寸不符',
  color_difference: '色差',
  qty_weight_discrepancy: '數量/重量 明顯誤差',
  material_function_mismatch: '材質/功能/參數 與訂單不符',
  outer_pack_damage: '外包裝破損',
  outer_pack_stain: '外包裝污漬',
  inspection_date: '檢驗日期',
  engineering_dept: '工程部',
  production_dept: '生產部',
  qa_dept: '品質部',
  handling_result: '處理結果',
  final_action_opinion: '最終處理意見',
  final_action_opinion_signed_by: '最終處理意見簽名',
  final_action_opinion_date: '最終處理意見日期',
  signed: '簽名',
  signature_date: '簽名日期',
  first_article_inspection: '首件檢驗',
  first_article_inspection_type: '首件檢驗類型',
  process_inspection: '過程檢驗',
  confirmation_purpose: '確認目的',
  production_line: '生產線',
  eco_friendly: '是否環保',
  voltage_frequency: '電壓/頻率',
  appearance: '外观',
  inspection_confirmer: '檢驗確認人',
  defective_remark: '不良备注',
  confirmer: '確認人',
  patrol: '巡查',
  patrol_date: '巡查日期',
  abnormal_description: '異常現象描述',
  patrol_inspector: '巡檢員',
  cause_analysis: '原因分析',
  improvement_action: '改善措施',
  filled_by: '填寫人',
  inspection_item: '檢驗項目',
  problem_description: '問題描述',
  components: '元器件',
  remote_distance: '遙控測距',
  durability: '耐久性',
  voltage_fluctuation: '電壓波動',
  standby_power: '待機功率',
  flame_retardant: '阻燃',
  fatal: '致命',
  major: '主要',
  minor: '次要',
  sampling_result: '抽檢結果',
  review_result: '會議結果',
  material: '材料资料',
  material2: '物料资料',
  project_manage2: '工程管理',
  material_stock2: '物料庫存',
  no_file: '無文件',
  doc_count: '文檔數量',
  img_count: '圖片數量',
  client_category: '客戶分類',
  client_code: '客戶代碼',
  production_standard: '生產標準',
  client_sort_name: '客戶簡稱',
  billing_month: '賬單月份',
  payment_status: '收款狀態',
  payment_responsible: '收款負責人',
  order_responsible: '跟單負責人',
  data_processing_completed: '數據處理完成',
  data_processing_failed: '數據處理失敗',
  year: '年份',
  business_license: '營業執照',
  material_cycle: '物料週期',
  inventory_count: '盤點數量',
  picking_date: '領料日期',
  usage_quantity: '用量',
  required_quantity: '所需数量',
  issued_quantity: '实发数量',
  remaining_quantity: '剩余数量',
  outsource_type: '外發類型',
  outsource_inquiry: '外發詢價',
  outsource_inquiry2: '外發採購詢價',
  production_process: '生產工藝',
  plan_start_date: '計劃上線日期',
  plan_start_date2: '計劃開始日期',
  tin_bar: '錫條',
  tin_bar_in: '錫條入倉',
  tin_bar_out: '錫條出倉',
  tin_bar_in_out_count: '錫條出入倉統計',
  tin_wire: '錫線',
  tin_wire_in: '錫線入倉',
  tin_wire_out: '錫線出倉',
  tin_wire_in_out_count: '錫線出入倉統計',
  tin_powder: '錫灰',
  tin_powder_recycle: '錫灰回收',
  tin_powder_out: '錫灰出庫',
  tin_powder_in_out_count: '錫灰出入庫統計',
  tin_dross: '錫渣',
  tin_dross_recycle: '錫渣回收',
  tin_dross_out: '錫渣出庫',
  tin_dross_in_out_count: '錫渣出入庫統計',
  material_receiver: '領料人',
  machine: '機臺',
  operator: '使用人',
  source_stock: '原倉存',
  abnormal_quantity: '異常數量',
  abnormal_description: '異常描述',
  remaining_stock: '結餘倉存',
  in_date: '入倉日期',
  out_date: '出倉日期',
  sampling_plan: '抽樣方案',
  production: '生產',
  quality_control: '品管',
  general_manager: '總經理',
  outsource_quantity: '外發數量',
  outsource_time: '外發時間',
  latest_material_arrival_time: '最遲物料到貨時間',
  is_material_ready: '是否齊料',
  customer_final_delivery_date: '客戶最終要求交期',
  ai_method: 'AI方式',
  smt_method: '貼片方式',
  bag: '袋子',
  piece_count: '個數',
  piece_count2: '件數',
  total_weight: '總重量',
  roll_count: '卷數',
  insertion: '插件',
  outsource_point: '外發加工點數',
  point_price: '點數單價',
  point_amount: '點數金額',
  minimum_charge: '最低消費',
  reported_person_count: '報工人數',
  wait: '等待等待',
  is_wait: '是否等待',
  wait_type: '等待類型',
  work_duration: '報工時長',
  work_duration2: '工時',
  pricing_method: '計價方式',
  wage_price: '人工單價',
  estimated_wage: '預計人工',
  process_price: '工序單價',
  finished_quantity: '完成數量',
  finished_percent: '完成比',
  percent: '百分比',
  price_in: '含稅單價',
  price_ex: '不含稅單價',
  amount_in: '含稅金額',
  amount_ex: '不含稅金額',
  disc_in: '含稅優惠價',
  disc_ex: '不含稅優惠價',
  manufact_cost: '製造成本',
  product_param: '產品參數',
  case_size: '外殼尺寸',
  power_lead: '電源引線',
  power_lead_input: '電源引線-輸入',
  power_lead_output: '電源引線-輸出',
  label: '標籤',
  purchase_quote: '採購報價',
  outsourced_supplier_stock: '外發供應商倉存',
  stock_in: '入庫',
  stock_out: '出庫',
  month_total: '本月合計',
  last_month_balance: '上月結存',
  material_stock_month: '材料月度倉存',
  material_stock_month2: '物料月度倉存',
  product_stock_month: '產品月度倉存',
  process_pricing_method: '工序計價方式',
  piecework_unit: '計件單位',
  alt_model: '代替型號',
  supplier_model: '供應商型號',
  bom_setting: 'BOM設定',
  bom_setting_history: 'BOM歷史記錄',
  drawing_code: '圖紙編碼',
  audit_permissions: '審覈權限',
  lighting_function: '燈光功能',
  border_color: '邊框顏色',
  production_cycle: '生產週期',
  payment_cycle: '付款週期',
  collection_cycle: '收款週期',
  purchase_transit: '採購在途',
  payment_reminders: '付款提醒',
  collection_reminders: '收款提醒',
  income_type: '收入類型',
  income_entry: '收入錄入',
  expense_type: '支出類型',
  expense_entry: '支出錄入',
  profit_report: '利潤表',
  expense_month: '費用月份',
  gross_profit: '毛利',
  gross_rate: '毛利率',
  net_profit: '淨利潤',
  sale_amount: '銷售金額',
  cost_amount: '成本金額',
  expense_money: '費用金額',
  purchase_out: '採購出庫',
  product_model: '產品型號',
  internal_no: '內部單號',
  material_list: '材料列表',
  delivery_method: '發貨方式',
  gd_manager: '工单管理员',
  keys_manage: '鎖匙管理',
  custodian: '保管人',
  equipment_name: '設備名稱',
  person_in_charge: '負責人',
  news: '新聞',
  cover: '封面封面',
  cover_image: '封面圖片',
  keywords: '關鍵字',
  transport_method: '運輸方式',
  min_pack: '最小包裝',
  lead_time: '交貨週期',
  quoter: '報價人',
  contact_phone: '聯絡電話',
  publish_time: '發佈時間',
  auto_publish_time: '自動發佈時間',
  custom_discount: '自定義折扣',
  member_level: '會員等級',
  recharge_rules: '儲值規則',
  member_recharge_rules: '會員儲值規則',
  recharge_bill: '儲值賬單',
  member_recharge_bill: '會員儲值賬單',
  member_tag: '會員標籤',
  balance_log: '餘額日誌',
  member_balance_log: '會員餘額日期',
  points_log: '積分日誌',
  member_points_log: '會員積分日期',
  is_finished: '是否完成',
  order_discount: '訂單折扣',
  order_discount_config: '訂單折扣設定',
  marketing_management: '營銷管理',
  coupon_issuance_history: '優惠券發放歷史',
  global_discount: '整單折扣',
  is_global_discount: '是否整單折扣',
  custom: '自定義',
  order_remark: '訂單備註',
  substitute: '替代',
  substitute_material: '替代材料',
  substitute_material2: '替代物料',
  backup_time: '備份時間',
  in_transit: '在途',
  pending_pick: '待領料',
  suggest_quantity: '建議採購數量',
  operate: '操作',
  main_data: '主數據',
  sales_followup: '業務跟單',
  product_optimization_tracking: '產品優化跟蹤',
  Precautionary_measures: '預防措施',
  measures_responsible: '措施負責人',
  file_name: '文件名稱',
  situation_description: '情況描述',
  effectiveness_confirmation: '效果確認',
  validator: '驗證人',
  confirm_date: '確認日期',
  specification_sheet: '規格書',
  paste: '粘貼',
  paste_image: '粘貼圖片',
  paste_file: '粘貼文件',








  // 餐飲管理系統
  production_location: '製作位置',
  food_category: '食品類別',
  option: '選項',
  option_money: '選項金額',
  picture: '圖片',
  food_material: '食材',
  food_material_category: '食材類別',
  table_number: '臺號',
  member_category: '會員分類',
  member_group: '會員分組',
  recharge: '充值',
  give_away: '贈送',
  card_number: '咭號',
  food_name: '食品名稱',
  food: '食品',
  shelf_life: '保質期',
  main_currency: '主貨幣',
  number_of_people: '人數',
  extra_order: '加菜',
  settlement: '結算',
  share_table: '搭檯',
  change_table: '轉臺',
  car_info: '車輛信息',
  driver_info: '司機信息',
  service_record: '服務記錄',
  open_cash_drawer: '打開錢箱',
  checklist: '查單',
  handover: '交班',
  production_location_setting: '製作位置設定',


  // 提示
  confirm_save: '確認儲存',
  confirm_cancel: '確認取消',
  confirm_delete: '確認刪除',
  confirm_audit: '確認審核',
  confirm_unaudit: '確認反審',
  confirm_obsolete: '確認作廢',
  confirm_transfer_in: '確定轉入',
  confirm_print: '是否列印',

  please_choose_detail: '請選擇明細',
  please_choose_data: '請選擇資料',
  please_choose_payment_method: '請選擇結算方式',
  please_choose_client: '請選擇客戶',
  please_choose_audited_data: '請選擇已審覈的數據',
  please_enter_login_name: '請輸入登入名',
  please_enter_password: '請輸入密碼',
  please_enter_org: '請輸入機構',
  org_error: '機構錯誤',

  save_success: '儲存成功',
  save_failed: '儲存失败',
  save_data_success: '儲存数据成功',
  save_data_failed: '儲存数据失败',
  delete_data_success: '刪除數據成功',
  delete_data_failed: '刪除數據失敗',
  audit_data_success: '審覈數據成功',
  audit_data_failed: '審覈數據失敗',
  unaudit_data_success: '反審數據成功',
  unaudit_data_failed: '反審數據失敗',
  move_failed: '移動失敗',

  success: '成功',
  failed: '失敗',
  error: '錯誤',
  unknown_error: '未知錯誤',
  will_delete_all: '會刪除所有下級資料',
  data_does_not_exist: '資料不存在',
  no_data: '無數據',
  no_matches_found: '未找到匹配項',
  prev_page: '上一頁',
  next_page: '下一頁',
  low_stocks: '庫存不足',
  insufficient_payment: '付款金額不足',
  login_name_or_password_wrong: '登入名或密碼錯誤',
  login_success: '登入成功',
  no_permission: '沒有權限',
  password_not_match: '密碼不匹配',
  password_changed_successfully: '修改密碼成功',
  verify_password_not_match: '驗證密碼不匹配',
  can_not_have_special_characters: '不能有特殊字符',
  can_not_empty: '不能為空',
  password_must_be_less_than_12_digits_and_no_spaces: '密碼必須小於12位，且不能出現空格',
  do_not_underline_at_the_beginning_and_end: '首尾不能出現下划線',
  this_value_already_exists: '該值已經存在',
  must_be_unique: "必須唯一",
  if_hold: '是否Hold單',
  data_not_found: '未找到對應數據',
  data_not_audited: '數據未審覈',
  lower_than_minimum_retail_price: '不能低於最低零售價',
  invoice: '發票',
  proofreading_invoice: '對數發票',
  receipt: '收據',
  order_invoice: '預訂發票',
  receipt_type: '單據類型',
  receipt_type2: '收款類型',
  change_client_well_del_all_continue: '重新選擇客戶，將會刪除所有明細數據，並且不可恢復，是否繼續',
  current_password_not_match: '当前密码不匹配',
  print_done: '列印完成',
  unselected_data: '未選擇數據',
  process_success: '處理成功',
  process_failed: '處理失敗',
  process_failed_please_try_agin: '處理失敗，請重試',
  process_timeout_please_try_agin: '处理逾時，请重试',
  process_error: '處理錯誤',
  copy_done: '複製成功',
  pay_amount_more_than_total_amount: '支付金額大於總金額',
  data_sent_successfully: '數據發送成功',
  invalid_email_format: '無效的E-mail格式',
  invalid_phone_format: '無效的電話格式',
  login_has_expired: '登入已過期，請重新登入',
  please_input_number_of_people: '請輸入人數',
  please_input_quantity: '請輸入數量',
  please_input_member_mobile: '請輸入會員電話',
  please_input_money: '請輸入金額',
  please_input_discount: '請輸入折扣',
  maximum_level_exceeded: '超出最大層級',
  no_member_found: '查無該會員',
  please_choose_new_table: '請選擇新餐檯',
  print_service_not_enabled: '打印服務未打開',
  detail_data_can_not_empty: '明細數據不能為空',
  used_data_cannot_be_deleted: "已被使用的資料不能刪除",
  must_be_unique_together: "必須是唯一的組合",
  image_upload_failed: "上載圖片失敗",
  video_upload_failed: "上載視頻失敗",
  image_size_cannot_be_larger_than: "圖片不能大於：",
  video_size_cannot_be_larger_than: "視頻不能大於：",
  export_success: '匯出成功',
  export_failed: '匯出失敗',
  no_files_on_the_clipboard: '剪貼板中沒有文件',
  no_image_files_on_the_clipboard: '剪貼板中沒有圖片文件',
  please_paste_the_image_file: '請粘貼圖片文件',
  upload_failed_please_try_again: '上載失敗，請重試',
  upload_successful: '上載成功',
  paste_successful: '粘貼成功',



  // 菜单
  menu_base_data: '基礎資料',
  menu_goods_category: '貨品分類',
  menu_goods_standard: '貨品規格',
  menu_goods: '貨品資料',
  menu_goods_category2: '商品分類',
  menu_goods_standard2: '商品規格',
  menu_goods2: '商品資料',
  menu_unit: '單位',
  menu_color: '顏色',
  menu_payment_method: '結算方式',
  menu_payment_method2: '支付方式',
  menu_brand: '品牌',
  menu_depart: '部門',

  menu_member_manage: '會員管理',
  menu_member_category: '會員分類',
  menu_member: '會員资料',
  menu_points_setting: '积分设置',
  menu_points_redeem: '积分兑换',

  menu_purchase_manage: '採購管理',
  menu_supplier_category: '供應商分類',
  menu_supplier: '供應商資料',
  menu_purchase_plan: '採購計劃',
  menu_purchase_order: '採購訂單',
  menu_purchase_apply: '採購申請',
  menu_purchase_in: '採購入庫',
  menu_purchase_return: '採購退貨',
  menu_purchase_auxiliary: '採購輔助表',
  menu_purchase_inquiry: '採購詢價',
  menu_supplier_quotes: '供應商報價',

  menu_process_plant_category: '加工廠分類',
  menu_process_plant: '加工廠資料',
  menu_outsource_manage: '外發管理',
  menu_outsource_out: '外發加工',
  menu_outsource_in: '外發收回',
  menu_outsource_report: '外發報表',
  menu_outsource_manage2: '外加工管理',
  menu_outsource_out2: '外加工發出',
  menu_outsource_in2: '外加工收入',
  menu_oem_in: '代加工收入',
  menu_oem_out: '代加工發出',

  menu_consignment_manage: '寄賣管理',
  menu_consignment_out: '寄賣發出明細',
  menu_consignment_out_detail: '寄賣發出',
  menu_consignment_in: '寄賣退貨',
  menu_consignment_in_detail: '寄賣退貨明細',
  menu_consignment_proceeds: '寄賣收款',
  menu_consignment_proceeds_detail: '寄賣收款明細',
  menu_consignment_uncollected: '寄賣未收款',
  menu_consignment_proceeds_report: '寄賣收款報表',

  menu_stock_transfer_out: '轉倉出',
  menu_stock_transfer_in: '轉倉入',

  menu_warehouse_manage: '倉庫管理',
  menu_warehouse: '倉庫資料',
  menu_stock_search: '庫存查詢',
  menu_stock_check: '庫存盤點',
  menu_stock_adjust: '庫存調整',
  menu_waste_in: '廢品入庫',
  menu_waste_out: '廢品出庫',
  menu_smart_replenishment: '智能補貨',
  menu_goods_assemble: '商品組裝',
  menu_goods_split: '商品拆分',
  menu_other_stock_in: '其他入倉',
  menu_other_stock_out: '其他出倉',
  menu_stock_in_type: '入庫類型',
  menu_stock_out_type: '出庫類型',

  menu_production_manage: '生產管理',
  menu_workshop: '車間設置',
  menu_bom_setting: 'BOM設定',
  menu_production_plan: '生產計劃',
  menu_production_list: '生產排單',
  menu_production_order: '生產訂單',
  menu_production_picking: '生產領料',
  menu_production_return: '生產退料',
  menu_product_in: '產品入庫',
  menu_product_in_detail: '產品入庫明細',
  menu_transfer_auxiliary: '轉貨輔助表',

  menu_sell_manage: '銷售管理',
  menu_wholesale_manage: '批發管理',
  menu_client_category: '客戶分類',
  menu_client: '客戶資料',
  menu_customer: '客戶資料',
  menu_customer2: '客戶信息',
  menu_client_contact: '客戶連絡人',
  menu_sell_order: '銷售訂單',
  menu_client_quote: '客戶報價',
  menu_sell_out: '銷售出庫',
  menu_sell_out_detail: '銷售出庫明細',
  menu_sell_return: '銷售退貨',
  menu_client_order: '客戶訂單',
  menu_sell_billing: '銷售開單',
  menu_client_return: '客戶退貨',
  menu_sell_summary: '銷售匯總',

  menu_sundry_manage: '雜項管理',
  menu_sundry_category: '雜項分類',
  menu_sundry_entry: '雜項錄入',
  menu_shop_sundry: '店鋪雜支',
  menu_fixed_expense: '固定支出',
  menu_shop_expense: '店鋪支出',
  menu_extra_expense: '額外支出',
  menu_salary_expenditure: '薪金支出',
  menu_expenditure_report: '支出報表',

  menu_finance_manage: '財務管理',
  menu_accountbook: '帳簿設置',
  menu_receipt_entry: '收款錄入',
  menu_payment_entry: '付款錄入',
  menu_receivable: '應收賬款',
  menu_payable: '應付賬款',
  menu_receipt_voucher: '收款憑證',
  menu_payment_voucher: '付款憑證',
  menu_receivable_offset: '應收賬款沖賬',
  menu_payable_offset: '應收賬款沖賬',
  menu_other_receipt: '其他收款',
  menu_other_payment: '其他付款',
  menu_expenses_type: '費用類型',
  menu_expenses_entry: '費用錄入',
  menu_supplier_account_balance: '供應商對賬結餘',
  menu_client_account_balance: '客戶對賬結餘',

  menu_settlement_manage: '結算管理',

  menu_addressee: '收貨人',
  menu_delivery_manage: '送貨管理',
  menu_delivery_person: '送貨人',
  menu_delivery_time: '送貨時段',
  menu_non_delivery_date: '不可送貨日期',
  menu_status: '狀態',
  menu_delivery_note: '送貨單',
  menu_delivery_billing: '送貨開單',
  menu_delivery_billing_report: '送貨開單報表',

  menu_maintain_manage: '維修管理',
  menu_acceptance_status: '受理狀態',
  menu_maintenance_status: '維修狀態',
  menu_notification_status: '通知状态',
  menu_maintain_note: '維修單',
  menu_reservation_maintain_note: '預約維修單',
  menu_maintain_note_report: '維修單報表',
  menu_reservation_maintain_note_report: '預約維修單報表',

  menu_system_setting: '系統設置',
  menu_operation_log: '操作日誌',
  menu_system_param: '系統參數',
  menu_user_group: '用戶組',
  menu_user: '使用者',
  menu_change_password: '修改密碼',

  menu_report: '報表',
  menu_goods_tracking: '貨品跟蹤',
  menu_purchase_in_report: '採購入庫報表',
  menu_purchase_in_count: '採購入庫統計',
  menu_stock_transfer_out_report: '轉倉出報表',
  menu_stock_count: '庫存統計',
  menu_retail_profit: '零售利潤',
  menu_netprofit_report: '純利表',
  menu_daily_settlement: '每日結算',
  menu_payment_method_daily: '每日結算-結算方式',
  menu_daily_settlement_variance: '每日結算差異',
  menu_retail_settlement: '零售結算',
  menu_retail_detail_report: '零售明細',
  menu_order_report: '預訂報表',
  menu_order_detail: '預訂明細',
  menu_order_statistics: '預訂統計',
  menu_obsolete_report: '作廢報表',
  menu_return_report: '退貨報表',
  menu_loss_report: '損耗報表',
  menu_profit_report: '利潤報表',
  menu_net_profit_report: '淨利潤報表',
  menu_purchase_detail: '採購明細',
  menu_sell_detail: '銷售明細',
  menu_inventory_warning: '庫存預警',
  menu_purchase_report: '採購報表',
  menu_replenish_manage: '補貨管理',
  menu_replenish_application: '補貨申請',

  menu_supplier_quote: '供應商報價',
  menu_purchase_receipt: '採購單',
  menu_object_manage: '項目管理',
  menu_quote_recipt_status: '報價單狀態',
  menu_project_setting: '項目設定',
  menu_project_category: '工程分類',
  menu_project_category2: '項目分類',
  menu_negotiation_category: '洽談分類',
  menu_project_negotiation: '項目洽談',
  menu_project_info: '項目資料',
  menu_project_quote: '工程報價',
  menu_project_quote2: '項目報價',
  menu_project_invoice: '工程發票',
  menu_design_company_setting: '設計公司設定',
  menu_design_quote: '設計報價',

  menu_income_expenditure_manage: '收付款管理',
  menu_income_type: '收款類型',
  menu_expenditure_type: '付款類型',

  menu_currency: '幣种',
  menu_bank_setting: '銀行設定',
  menu_bank_journal_type: '日記賬類別',
  menu_cash_journal_entry: '現金日記帳錄入',
  menu_bank_journal_entry: '銀行日記賬錄入',
  menu_invoice_journal_entry: '發票日記賬錄入',
  menu_check_journal_entry: '支票日記賬錄入',
  menu_debit_credit_entry: '借貸錄入',
  menu_debit_entry: '借款錄入',
  menu_credit_entry: '貸款錄入',
  menu_reimbursement_people: '報銷人',
  menu_reimburse_entry: '報銷錄入',

  menu_project_quote_report: '工程報價報表',
  menu_design_quote_report: '設計報價報表',
  menu_receipt_report: '收款報表',
  menu_payment_report: '付款報表',
  menu_receipt_payment_detail: '收支明細',
  menu_project_receipt_payment_detail: '工程收支明細',
  menu_profit_report: '利潤表',
  menu_cash_journal_report: '現金日記賬報表',
  menu_bank_journal_report: '銀行日記賬報表',
  menu_invoice_journal_report: '發票日記賬報表',
  menu_check_journal_report: '支票日記賬報表',
  menu_debit_credit_report: '借貸報表',
  menu_reimburse_report: '報銷報表',

  menu_project_follow_up: '項目跟進',
  menu_project_manage: '項目管理',
  menu_after_sale_manage: '售後管理',
  menu_after_sale: '售後',
  menu_customer_complaint: '客訴',
  menu_problem_collection: '問題收集',
  menu_problem_handling: '問題處理',
  menu_client_manage: '客戶管理',
  menu_customer_manage: '客戶管理',
  menu_receipt_type: '收款類型',
  menu_material_category: '材料分類',
  menu_product_category: '產品分類',
  menu_product_info: '產品資料',
  menu_semi_finished_category: '半成品分類',
  menu_semi_finished: '半成品資料',
  menu_area: '地區',
  menu_problem_type: '問題類型',
  menu_handling_type: '處理類型',
  menu_unfinished_problem: '未完成問題',
  menu_repayment_entry: '還款錄入',
  menu_credit_repayment_entry: '貸款還款錄入',
  menu_credit_report: '貸款報表',
  menu_purchase_check_report: '採購對數報表',
  menu_monthly_balance: '月結',
  menu_daily_balance_report: '日結報表',
  menu_daily_balance_detail: '日結明細',
  menu_edition_fee: '版費',
  menu_edition_fee_return: '版費退回',
  menu_staff_info: '員工資料',
  menu_settlement: '結算',
  menu_supplier_statement: '供應商對賬單',
  menu_client_statement: '客戶對賬單',
  menu_attendance_manage: '考勤管理',
  menu_schedules_setting: '班次定義',
  menu_holiday_entry: '假日登記',
  menu_absence_type: '缺勤類型',
  menu_absence_entry: '缺勤登記',
  menu_special_record: '特殊記錄',
  menu_attendance_entry: '考勤錄入',
  menu_attendance_statistics: '考勤統計',
  menu_attendance_type: '考勤類型',

  menu_salary_manage: '薪資管理',
  menu_process_setting: '工序設定',
  menu_process: '工序',
  menu_piecework_data_entry: '計件數據錄入',
  menu_piecework_report: '計件報表',
  menu_salary_statistics: '薪資統計表',
  menu_salary_report: '薪資報表',
  menu_piecework_order: '計件訂單',
  menu_piecework_entry: '計件錄入',
  menu_wage_entry: '薪資錄入',

  menu_purchase_detail: '採購明細',
  menu_sell_detail: '銷售明細',
  menu_stock_alert: '倉存預警',
  menu_monthly_receivable_detail: '月份應收款往來',
  menu_monthly_payable_detail: '月份應付款往來',
  menu_cash_account: '現金帳',
  menu_profit_statistics: '利潤統計表',
  menu_supplier_manage: '供應商管理',
  menu_payment_type: '付款類型',
  menu_wx_mall: '微信商城',
  menu_sort: '分類',
  menu_order_status: '訂單狀態',
  menu_wx_order: '微信訂單',

  menu_size: '尺碼',
  menu_order_management: '訂單管理',
  menu_finished_order: '已完成訂單',
  menu_product_stuff_search: '產品材料查詢',
  menu_product_material_search: '產品材料查詢',
  menu_unsalable_report: '滯銷報表',
  menu_bad_goods_transfer_out: '壞貨轉出',
  menu_terms_setting: '條款設定',

  menu_task_type: '任務類型',
  menu_task_finish_type: '任務完成類型',
  menu_task: '任務',
  menu_project_progress: '項目進度',
  menu_issue_manage: '问题管理',
  menu_issue_category: '問題分類',
  menu_issue_collection: '問題收集',
  menu_material_stock: '材料倉存',
  menu_product_stock: '產品倉存',
  menu_sell_report: '销售报表',


  // 餐飲管理系統
  menu_food_setting: '食品設定',
  menu_food_category: '食品類別',
  menu_food_info: '食品資料',
  menu_food_material_category: '食材類別',
  menu_food_material: '食材資料',
  menu_option: '選項',
  menu_dining_table_setting: '餐檯設定',
  menu_area2: '區域',
  menu_table_number: '檯號',
  menu_recharge_offer: '充值優惠',
  menu_member_recharge: '會員充值',
  menu_recharge: '充值管理',
  menu_discount_manage: '折扣管理',
  menu_discount_manage2: '優惠管理',
  menu_discount: '折扣錄入',
  menu_business_report_day: '營業日報',
  menu_business_report_month: '營業月報',
  menu_sales_ranking: '銷量排行',
  menu_food_material_report: '食材報表',
  menu_param: '參數設定',
  menu_production_location: '製作位置',
  menu_service: '服務設定',

  menu_client_follow_up: '客戶跟進',
  menu_follow_up_type: '跟進類型',
  menu_follow_up_entry: '跟進錄入',
  menu_follow_up_report: '跟進情況表',
  menu_sell_offer: '銷售報價',
  menu_purchase_offer: '採購報價',

  menu_product_catetory: '產品分類',
  menu_material: '材料資料',
  menu_product: '產品資料',
  menu_product2: '成品資料',
  menu_product_process: '產品工序',
  menu_personnel_manage: '人事管理',
  menu_department: '部門',
  menu_job_title: '職位',
  menu_job_post: '職位',
  menu_staff: '員工資料',
  menu_grade: '等級',

  menu_store_manage: '賣場管理',
  menu_goods_listing: '商品上架',
  menu_goods_drop: '商品落架',
  menu_retail_special: '零售特價',
  menu_member_special: '會員特價',
  menu_purchase_gift: '買送促銷',
  menu_full_reduction_discount: '滿減優惠',
  menu_special_package: '特價打包',
  menu_retail_return: '零售退貨',
  menu_daily_flow_report: '每日流水報表',
  menu_setmeal: '套餐',
  menu_length: '長度',
  menu_height: '高度',
  menu_cash_coupon: '現金券',
  menu_coupon: '優惠券',
  menu_specials: '商品特價',
  menu_member_specials: '會員特價',
  menu_consignment_category: '寄賣分類',
  menu_post: '崗位',
  menu_active_status: '在職狀態',

  menu_service_category: '服務分類',
  menu_service_manage: '服務管理',
  menu_trademark_category: '商標分類',
  menu_order_manage: '訂單管理',
  menu_about_us: '關於我們',
  menu_stock_state: '倉存狀態',
  menu_inspection_report: '檢驗報告',
  menu_quality_control: '品質控制',
  menu_quality_inspection: '品質檢驗',
  menu_outgoing_inspection: '出貨檢驗',
  menu_invoicing_record: '開票記錄',
  menu_receipt_record: '收票記錄',
  menu_Consumption_report: '消費報表',

  menu_goods_disassembly_assembly_manage: '商品拆裝',
  menu_goods_disassembly: '商品拆分',
  menu_goods_assembly: '商品組裝',
  menu_reserve_manage: '預約管理',
  menu_reserve_enter: '預約登記',
  menu_online_reserve: '在線預約',
  menu_reserve_dispatch: '預約調度',
  menu_reserve_reminder: '預約提醒',
  menu_service_manage: '服務管理',
  menu_work_order_state: '工單狀態',
  menu_work_order_enter: '工單錄入',
  menu_item_type: '項目類型',
  menu_item_setting: '項目設定',
  menu_collect_feedback: '收集反饋',

  menu_sample_record: '樣板記錄',
  menu_material_inspection: '材料檢驗',

  CREATE: '新增',
  UPDATE: '修改',
  DELETE: '刪除 ',
  AUDIT: '審核',
  UNAUDIT: '反審',
  LOGIN: '登錄',
  LOGOUT: '註銷',
  log_time: '日誌時間',
  log_date: '日誌日期',
  log_detail: '日誌明細',
  new_value: '新值',
  old_value: '舊值',
  no_log_data: '沒有日誌數據',
  change_item: '變更項',
  updated: '更新',
  inserted: '插入',
  deleted: '刪除',
}